import script from "./DownloadArea.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadArea.vue?vue&type=script&setup=true&lang=js"

import "./DownloadArea.vue?vue&type=style&index=0&id=bb56ab5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb56ab5c"]])

export default __exports__